<template>
  <a-modal
    :visible="visible"
    :title="previewTitle"
    :width="560"
    :footer="null"
    :maskClosable="true"
    @cancel="onClose"
  >
    <div v-if="!shownQuestions.length" class="pv-empty">该问卷暂无题目（有显示条件的题目在满足条件后显示）</div>

    <!-- 题目区样式与播放端弹窗（icu-official-website / VideoQuestionnaire.vue）保持一致 -->
    <div v-for="(q, idx) in shownQuestions" :key="q.id" class="pv-question">
      <div class="pv-question-title">
        <span class="pv-q-index">{{ idx + 1 }}.</span>
        <span>{{ q.title }}</span>
        <span v-if="q.isRequired === 1" class="pv-required">*</span>
        <span v-if="q.type === 'checkbox'" class="pv-q-type">【多选题】</span>
      </div>
      <div class="pv-question-body">
        <!-- 单选 -->
        <a-radio-group v-if="q.type === 'radio'" v-model="answers[q.id]">
          <a-radio v-for="o in q.options || []" :key="o.id" :value="o.id">{{ o.content }}</a-radio>
        </a-radio-group>

        <!-- 多选 -->
        <a-checkbox-group v-else-if="q.type === 'checkbox'" v-model="answers[q.id]">
          <a-checkbox v-for="o in q.options || []" :key="o.id" :value="o.id">{{ o.content }}</a-checkbox>
        </a-checkbox-group>

        <!-- 填空 -->
        <a-textarea v-else-if="q.type === 'input'" v-model="answers[q.id]" :rows="3" placeholder="请输入答案" />

        <!-- 多行填空 -->
        <a-textarea v-else-if="q.type === 'textarea'" v-model="answers[q.id]" :rows="4" placeholder="请输入内容" />

        <!-- 评分 -->
        <div v-else-if="q.type === 'score'" class="pv-score-row">
          <a-rate v-model="answers[q.id]" :count="rateCount(q)" :allow-half="false" />
          <span class="pv-score-range">（{{ scoreMin(q) }} ~ {{ scoreMax(q) }} 分）</span>
        </div>

        <div v-else class="pv-empty">暂不支持的题型：{{ q.type }}</div>
      </div>
    </div>

    <div class="pv-footer">
      <a-button @click="onClose">关闭</a-button>
      <a-button style="margin-left: 8px" @click="reset">重置重答</a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'QuestionnairePreview',
  props: {
    visible: { type: Boolean, default: false },
    questionnaire: { type: Object, default: null }
  },
  data() {
    return {
      answers: {}
    }
  },
  computed: {
    previewTitle() {
      const q = this.questionnaire
      const n = q && q.questions ? q.questions.length : 0
      return (q ? q.title : '问卷预览') + '（共 ' + n + ' 题，条件满足后逐题显示）'
    },
    shownQuestions() {
      const q = this.questionnaire
      if (!q || !q.questions) return []
      const list = []
      q.questions.forEach(item => {
        if (this.isShown(item)) list.push(item)
      })
      return list
    }
  },
  watch: {
    visible(val) {
      if (val) this.reset()
    }
  },
  methods: {
    isShown(q) {
      const cond = q.showCondition
      if (!cond || typeof cond !== 'object') return true
      const keys = Object.keys(cond)
      if (!keys.length) return true
      // 多条件 AND：每个前置题都须已作答且命中对应选项
      for (let i = 0; i < keys.length; i++) {
        const pqId = Number(keys[i])
        const needOptId = cond[keys[i]]
        const val = this.answers[pqId]
        if (val == null) return false
        if (Array.isArray(val)) {
          if (val.indexOf(needOptId) < 0) return false
        } else if (Number(val) !== Number(needOptId)) {
          return false
        }
      }
      return true
    },
    scoreMin(q) {
      const v = q.scoreMin != null ? q.scoreMin : q.minScore
      return v != null ? Number(v) : 1
    },
    scoreMax(q) {
      const v = q.scoreMax != null ? q.scoreMax : q.maxScore
      return v != null ? Number(v) : 5
    },
    // 评分题档位数：按接口 min~max 生成星星数量（如 1~10 显示 10 颗星）
    rateCount(q) {
      return this.scoreMax(q) - this.scoreMin(q) + 1
    },
    reset() {
      this.answers = {}
    },
    onClose() {
      this.reset()
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 与播放端弹窗（VideoQuestionnaire.vue）题目区样式保持一致 */
.pv-empty {
  color: #999999;
  font-size: 13px;
  padding: 12px 0;
  text-align: center;
}
.pv-question {
  margin-bottom: 22px;
}
.pv-question-title {
  font-size: 14px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.5;
}
.pv-q-index {
  margin-right: 4px;
}
.pv-required {
  color: #f5222d;
  margin-left: 4px;
}
.pv-q-type {
  color: #999999;
  margin-left: 6px;
  font-size: 12px;
}
.pv-question-body .ant-radio-wrapper,
.pv-question-body .ant-checkbox-wrapper {
  display: block;
  margin: 8px 0;
  font-size: 14px;
}
.pv-score-row {
  display: flex;
  align-items: center;
}
.pv-score-row .ant-rate {
  font-size: 20px;
}
.pv-score-range {
  color: #999999;
  font-size: 12px;
  margin-left: 8px;
}
.pv-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}
</style>
